import { CognitoUserPool } from 'amazon-cognito-identity-js';
import CryptoJS from 'crypto-js';

const poolData = {
	UserPoolId: process.env.REACT_APP_COGNITO_POOL_ID,
	ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
};

const pool = new CognitoUserPool(poolData);

const getSecretHash = (username) =>
	CryptoJS.enc.Base64.stringify(
		CryptoJS.HmacSHA256(
			username + process.env.REACT_APP_COGNITO_CLIENT_ID,
			process.env.REACT_APP_COGNITO_CLIENT_SECRET
		)
	);

// Patch the internal client to inject SECRET_HASH into all Cognito auth requests
// because amazon-cognito-identity-js doesn't support client secrets natively.
const originalRequest = pool.client.request.bind(pool.client);
pool.client.request = (operation, params, callback) => {
	const patched = { ...params };

	if (operation === 'InitiateAuth' && patched.AuthParameters?.USERNAME) {
		patched.AuthParameters = {
			...patched.AuthParameters,
			SECRET_HASH: getSecretHash(patched.AuthParameters.USERNAME),
		};
	} else if (
		(operation === 'ForgotPassword' || operation === 'ConfirmForgotPassword') &&
		patched.Username
	) {
		patched.SecretHash = getSecretHash(patched.Username);
	} else if (
		operation === 'RespondToAuthChallenge' &&
		patched.ChallengeResponses?.USERNAME
	) {
		patched.ChallengeResponses = {
			...patched.ChallengeResponses,
			SECRET_HASH: getSecretHash(patched.ChallengeResponses.USERNAME),
		};
	}

	return originalRequest(operation, patched, callback);
};

export default pool;
